module.exports = __webpack_public_path__ + "img/14.7640c5df.png";